(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/member-accordion.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/member-accordion.js');
'use strict';

const {
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionDetails
} = svs.ui.ReactAccordion;
const {
  ReactButton: Button
} = svs.ui;
const {
  memberStates
} = svs.arena.constants;
const {
  ErrorMessage
} = svs.arena.shared.components;
const {
  activeMembers: getActiveMembers
} = svs.arena.pages.teams.helpers;
const {
  fetchTeamDetails,
  fetchTeamInviteId,
  createTeamInviteId
} = svs.arena.store.teams.actions;
const {
  ActiveMember,
  InactiveMember
} = svs.arena.pages.teams.teamMembers;
const {
  TeamEmail,
  TeamInviteLink,
  AllAdminCheckbox
} = svs.arena.pages.teams.components;
const memberOrMembers = amount => amount > 1 ? 'medlemmar' : 'medlem';

const ExpandedListener = _ref => {
  let {
    expanded,
    setIsExpanded
  } = _ref;
  React.useEffect(() => {
    setIsExpanded(expanded);
  }, [setIsExpanded, expanded]);
  return null;
};
const MemberAccordion = _ref2 => {
  var _myTeamDetails$member, _myTeamDetails$member2;
  let {
    team,
    teamId
  } = _ref2;
  const dispatch = ReactRedux.useDispatch();
  const inviteIds = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.inviteIds;
  }) || [];
  const allTeamDetails = ReactRedux.useSelector(state => {
    var _state$teams2;
    return (_state$teams2 = state.teams) === null || _state$teams2 === void 0 ? void 0 : _state$teams2.teamDetails;
  }) || [];
  const myTeamDetails = allTeamDetails.find(item => item.syndicateId === teamId);
  const [isError, setIsError] = React.useState(false);
  const [isShowTeamEmail, setIsShowTeamEmail] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isExpandedTrack, setIsExpandedTrack] = React.useState(true);
  const {
    syndicateName,
    isLeader,
    adminManagedWagers
  } = team || {};
  const activeMembers = getActiveMembers(myTeamDetails === null || myTeamDetails === void 0 ? void 0 : myTeamDetails.members);
  const inactiveMembers = myTeamDetails === null || myTeamDetails === void 0 || (_myTeamDetails$member = myTeamDetails.members) === null || _myTeamDetails$member === void 0 ? void 0 : _myTeamDetails$member.filter(_ref3 => {
    let {
      memberState
    } = _ref3;
    return memberState === memberStates.INACTIVE;
  });
  const inactiveMemberCount = (inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.length) || (team === null || team === void 0 ? void 0 : team.fullMemberCount) - (team === null || team === void 0 ? void 0 : team.activeMemberCount);
  const hasInactiveMembers = inactiveMemberCount > 0;
  const membersNoBalance = myTeamDetails === null || myTeamDetails === void 0 || (_myTeamDetails$member2 = myTeamDetails.members) === null || _myTeamDetails$member2 === void 0 ? void 0 : _myTeamDetails$member2.filter(_ref4 => {
    let {
      memberBalance,
      memberState
    } = _ref4;
    return parseInt(memberBalance, 10) === 0 && memberState === memberStates.ACTIVE;
  }).length;

  React.useEffect(() => {
    if (isExpanded && isLeader) {
      svs.arena.logger.debug('MemberAccordion, useEffect...fetchInviteLink for team...');
      const inviteLink = inviteIds.find(item => item.teamId === teamId);
      if (inviteLink) {
        svs.arena.logger.debug('*** InviteLink in useEffect: found item teamId, link ', teamId, inviteLink);
        const linkDate = new Date(inviteLink.validTo).valueOf();
        const now = new Date().valueOf();
        const isOk = linkDate - now > 24 * 60 * 60 * 1000; 

        if (!isOk) {
          svs.arena.logger.debug('*** InviteLink in useEffect: not valid, creating new link', linkDate, now, isOk);
          dispatch(createTeamInviteId({
            teamId
          }));
        }
      } else {
        svs.arena.logger.debug('*** InviteLink in useEffect: did NOT found link, try to get it...');
        dispatch(fetchTeamInviteId(teamId));
      }
    }
  }, [dispatch, inviteIds, isExpanded, isLeader, teamId]);
  const trackClick = () => {
    setIsExpandedTrack(current => !current);
    const track = {
      category: 'spela-tillsammans',
      action: 'members',
      opt_label: isExpandedTrack ? 'card_click' : 'card_closed'
    };
    svs.components.analytics.trackEvent(track);
  };
  React.useEffect(() => {
    const fetchTeamDetailsAsync = async () => {
      const fetchData = await dispatch(fetchTeamDetails(teamId));
      if (RTK.isRejected(fetchData)) {
        return setIsError(true);
      }
      setIsError(false);
    };
    if (isExpanded) {
      svs.arena.logger.debug('MemberAccordion, useEffect...fetchteamDetails for team...');
      const teamData = allTeamDetails.find(item => item.syndicateId === teamId);
      if (teamData) {
        svs.arena.logger.debug('*** teamData in useEffect: found item for team ', teamId, teamData);
      } else {
        svs.arena.logger.debug('*** teamData in useEffect: did NOT found teamData, try to get it...');
        fetchTeamDetailsAsync();
      }
    }
  }, [dispatch, allTeamDetails, isExpanded, teamId]);
  const memberAccordionDescription = () => {
    let extraText = '';
    if (membersNoBalance && hasInactiveMembers) {
      extraText = ", varav ".concat(inactiveMemberCount, " vilande och ").concat(membersNoBalance, " utan saldo");
    } else if (membersNoBalance) {
      extraText = ", varav ".concat(membersNoBalance, " utan saldo");
    } else if (hasInactiveMembers) {
      extraText = ", varav ".concat(inactiveMemberCount, " vilande");
    }
    return "".concat(team === null || team === void 0 ? void 0 : team.fullMemberCount, " ").concat(memberOrMembers(team === null || team === void 0 ? void 0 : team.fullMemberCount)).concat(extraText);
  };
  const onShowEmail = () => {
    const track = {
      category: 'spela-tillsammans',
      action: 'all_members_email',
      opt_label: 'show_email_field'
    };
    svs.components.analytics.trackEvent(track);
    setIsShowTeamEmail(true);
  };
  return React.createElement(Accordion, {
    className: "margin-top-1-override",
    isFlat: true
  }, React.createElement(AccordionItem, {
    onChange: trackClick
  }, React.createElement(ExpandedListener, {
    setIsExpanded: expanded => setIsExpanded(!expanded)
  }), React.createElement(AccordionSummary, {
    className: "member-accordion"
  }, React.createElement("div", null, React.createElement("h4", {
    className: "accordion-h4 override"
  }, React.createElement("span", {
    className: "f-medium accordion-h4 override"
  }, "Medlemmar")), React.createElement("span", {
    className: "accordion-span override"
  }, memberAccordionDescription()))), React.createElement(AccordionDetails, null, isExpanded && React.createElement("div", null), isError && React.createElement(ErrorMessage, {
    actions: [{
      handleClick: () => dispatch(fetchTeamDetails(teamId)),
      text: 'Försök igen'
    }],
    header: "Tillf\xE4lligt fel!",
    icon: "exclamation-sign",
    text: "N\xE5gonting gick fel n\xE4r medlemmar skulle visas upp. F\xF6rs\xF6k igen om en stund."
  }), !isError && React.createElement(React.Fragment, null, React.createElement("div", null, isLeader && React.createElement(AllAdminCheckbox, {
    isAdminManagedWagers: adminManagedWagers,
    teamId: teamId
  }), activeMembers === null || activeMembers === void 0 ? void 0 : activeMembers.map(member => React.createElement(ActiveMember, {
    isLeader: isLeader,
    key: member.customerId,
    member: member,
    teamId: teamId,
    teamName: syndicateName
  }))), !(team !== null && team !== void 0 && team.isInactive) && (inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.length) > 0 && React.createElement(React.Fragment, null, React.createElement("h4", {
    className: "h4 margin-top-2 margin-bottom-1"
  }, React.createElement("span", {
    className: "f-medium"
  }, " Vilande ")), inactiveMembers === null || inactiveMembers === void 0 ? void 0 : inactiveMembers.map(member => React.createElement(InactiveMember, {
    isLeader: isLeader,
    key: member.customerId,
    member: member,
    teamId: teamId,
    teamName: syndicateName
  }))), isShowTeamEmail && React.createElement("div", {
    className: "margin-top-3"
  }, React.createElement(TeamEmail, {
    activeMembers: activeMembers || [],
    inactiveMembers: inactiveMembers,
    onHide: () => setIsShowTeamEmail(false),
    teamId: teamId
  })), !isShowTeamEmail && (team === null || team === void 0 ? void 0 : team.fullMemberCount) > 1 && React.createElement("div", {
    className: "margin-top-3"
  }, React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: onShowEmail,
    size: 200,
    transparent: true
  }, "skicka e-post till laget")), isLeader && React.createElement(TeamInviteLink, {
    fullMemberCount: team === null || team === void 0 ? void 0 : team.fullMemberCount,
    isExpanded: isExpanded,
    teamId: teamId
  })))));
};
svs.arena.pages.teams.components.MemberAccordion = MemberAccordion;

 })(window);